"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  &__overlay {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background-color: rgba(74, 74, 74, 0.7);\n  }\n\n  &__content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    outline: none;\n    pointer-events: none;\n  }\n\n  &__content * {\n    pointer-events: all;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ModalAdapter = function ModalAdapter(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["isOpen", "onClose", "className"]);
  var contentClassName = "".concat(className, "__content");
  var overlayClassName = "".concat(className, "__overlay");
  return _react["default"].createElement(_reactModal["default"], (0, _extends2["default"])({
    ariaHideApp: false,
    isOpen: isOpen,
    className: contentClassName,
    portalClassName: className,
    overlayClassName: overlayClassName,
    onRequestClose: onClose
  }, props));
}; // --------------------------------------------------
// Props
// --------------------------------------------------


ModalAdapter.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  onClose: _propTypes["default"].func.isRequired
};
ModalAdapter.defaultProps = {};
var ModalContent = (0, _styledComponents["default"])(ModalAdapter).attrs({
  suppressClassNameWarning: true
})(_templateObject());
var _default = ModalContent;
exports["default"] = _default;